import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "institutional-accordion" }
const _hoisted_2 = { class: "accordion-content" }
const _hoisted_3 = { class: "q-mb-lg" }
const _hoisted_4 = { class: "row items-center q-gutter-sm" }
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = { class: "row justify-center" }
const _hoisted_7 = {
  key: 0,
  class: "column items-center q-gutter-xs"
}
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = {
  key: 1,
  class: "text-grey-6"
}
const _hoisted_10 = { class: "row justify-center" }
const _hoisted_11 = { class: "row justify-center q-gutter-xs" }
const _hoisted_12 = { class: "row justify-center" }
const _hoisted_13 = { class: "row justify-center" }
const _hoisted_14 = { class: "row justify-center" }
const _hoisted_15 = {
  key: 0,
  class: "column items-center q-gutter-xs"
}
const _hoisted_16 = ["src", "onClick"]
const _hoisted_17 = {
  key: 1,
  class: "text-grey-6"
}
const _hoisted_18 = { class: "row justify-center" }
const _hoisted_19 = { class: "row justify-center" }
const _hoisted_20 = { class: "accordion-content" }
const _hoisted_21 = { class: "row justify-center" }
const _hoisted_22 = {
  key: 0,
  class: "column items-center q-gutter-xs"
}
const _hoisted_23 = ["src", "onClick"]
const _hoisted_24 = {
  key: 1,
  class: "text-grey-6"
}
const _hoisted_25 = { class: "row justify-center" }
const _hoisted_26 = { class: "row justify-center" }
const _hoisted_27 = { class: "row justify-center" }
const _hoisted_28 = {
  key: 0,
  class: "column items-center q-gutter-xs"
}
const _hoisted_29 = ["src", "onClick"]
const _hoisted_30 = {
  key: 1,
  class: "text-grey-6"
}
const _hoisted_31 = { class: "row justify-center" }
const _hoisted_32 = { class: "row justify-center" }
const _hoisted_33 = { class: "accordion-content" }
const _hoisted_34 = { class: "q-mb-lg" }
const _hoisted_35 = { class: "row q-mt-sm q-gutter-md" }
const _hoisted_36 = { class: "row justify-center" }
const _hoisted_37 = {
  key: 0,
  class: "column items-center q-gutter-xs"
}
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = {
  key: 1,
  class: "text-grey-6"
}
const _hoisted_40 = { class: "row justify-center" }
const _hoisted_41 = { class: "row justify-center" }
const _hoisted_42 = ["src"]

import { ref, computed, watchEffect, watch } from 'vue';
import type { QTableColumn } from 'quasar';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import type { InstitutionalViewAccordionData } from '@/mocks/institutional/institutionalViewMock';
import { validarTodosCadastro } from '@/utils/validacoesInstitucionais';

import { useInstitutionalStore } from '@/stores/institutionalStore'
type TelaInicialRow = {
  id: number;
  tela: string;
  posicao: number;
  ordem: number;
  tempo: number;
};

type TelaAtmRow = {
  id: number;
  botao: string;
  posicao: number;
};

type TelaAguardeRow = {
  id: number;
  tela: string;
  posicao: number;
};

type TelaAberturaRow = {
  id: number;
  tela: string;
  posicao: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalAccordion',
  props: {
    accordionsData: {},
    mode: {}
  },
  setup(__props: any, { expose: __expose }) {

const institutionalStore = useInstitutionalStore()


const $q = useQuasar();

/* =========================================================
 * PROPS
 * ======================================================= */

// const props = defineProps<{
//   accordionsData?: {
//     telasIniciais: any[];
//     telasAtm: any[];
//     telasAguardeGeral: any[];
//     telasAguardeChip: any[];
//     telasAbertura: any[];
//     imagens?: {
//       posicaoImagem: number;
//       urlS3: string;
//       duracaoImagem?: number;
//     }[];
//     exibeTelaAbertura?: boolean;
//     alterarTelaAbertura?: boolean;
//   };
//   mode?: 'view' | 'edit';
// }>();
const props = __props;


const opcoesTempoExibicao = Array.from({ length: 30 }, (_, i) => i + 1)

const isViewMode = computed(() => props.mode === 'view');

const POSICOES_TELA_INICIAL = [1, 2, 3, 4, 8, 9, 10, 11]
const POSICOES_TELA_AGUARDE = [6, 7]
const POSICOES_TELA_ABERTURA = [5]

/* =========================================================
 * 🆕 MAPEAMENTO DE POSIÇÕES (1-11)
 * ======================================================= */
const imagensPorPosicao = ref<Record<number, { file: File | null; url: string | null }>>({
  1: { file: null, url: null },  // Tela Inicial 1
  2: { file: null, url: null },  // Tela Inicial 2
  3: { file: null, url: null },  // Tela Inicial 3
  4: { file: null, url: null },  // Tela Inicial 4
  5: { file: null, url: null },  // Tela de Abertura
  6: { file: null, url: null },  // Tela Aguarde Geral
  7: { file: null, url: null },  // Tela Aguarde Chip
  8: { file: null, url: null },  // Botão ATM 1
  9: { file: null, url: null },  // Botão ATM 2
  10: { file: null, url: null }, // Botão ATM 3
  11: { file: null, url: null }, // Botão ATM 4
});

/* =========================================================
 * REFS BASE (com posições mapeadas)
 * ======================================================= */
const telasIniciais = ref<any[]>([
  { id: 1, tela: 'Tela 1', posicao: 1, ordem: 1, tempo: 10 },
  { id: 2, tela: 'Tela 2', posicao: 2, ordem: 2, tempo: 10 },
  { id: 3, tela: 'Tela 3', posicao: 3, ordem: 3, tempo: 10 },
  { id: 4, tela: 'Tela 4', posicao: 4, ordem: 4, tempo: 10 },
]);

const telasAtm = ref<any[]>([
  { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
  { id: 9, botao: 'Recarga celular', posicao: 9 },
  { id: 10, botao: 'Mais serviços', posicao: 10 },
  { id: 11, botao: 'Depositar dinheiro', posicao: 11 },
]);

const telasAguardeGeral = ref<any[]>([
  { id: 6, tela: 'Tela Geral', posicao: 6 },
]);

const telasAguardeChip = ref<any[]>([
  { id: 7, tela: 'Tela Chip', posicao: 7 },
]);

const telasAbertura = ref<any[]>([
  { id: 5, tela: 'Tela Abertura', posicao: 5 },
]);

/* =========================================================
 * SINCRONIZAÇÃO VIEW MODE
 * ======================================================= */

 
const resetImagens = () => {
  Object.keys(imagensPorPosicao.value).forEach((key) => {
    imagensPorPosicao.value[Number(key)] = {
      file: null,
      url: null
    };
  });
};

const temImagemTelaInicial = computed(() => {
  const posicoes = [1, 2, 3, 4, 8, 9, 10, 11]
  return posicoes.some(pos => imagensPorPosicao.value[pos]?.url)
})

const temImagemTelaAguarde = computed(() => {
  const posicoes = [6, 7]
  return posicoes.some(pos => imagensPorPosicao.value[pos]?.url)
})


const limparPosicoes = (posicoes: number[]) => {
  usuarioInteragiu.value = true

  const novoMapa = { ...imagensPorPosicao.value }

  posicoes.forEach((posicao) => {
    const oldUrl = novoMapa[posicao]?.url
    if (oldUrl && oldUrl.startsWith('blob:')) {
      URL.revokeObjectURL(oldUrl)
    }

    novoMapa[posicao] = {
      file: null,
      url: null
    }
  })

  imagensPorPosicao.value = novoMapa
}

/*const removerImagem = (posicao: number) => {
  usuarioInteragiu.value = true

  const imagemAtual = imagensPorPosicao.value[posicao]
  if (imagemAtual?.url && imagemAtual.url.startsWith('blob:')) {
    URL.revokeObjectURL(imagemAtual.url)
  }

  imagensPorPosicao.value = {
    ...imagensPorPosicao.value,
    [posicao]: {
      file: null,
      url: null
    }
  }
}*/

// INICIO
const removerImagem = (posicao: number) => {
  usuarioInteragiu.value = true

  const imagemAtual = imagensPorPosicao.value[posicao]

  if (imagemAtual?.url && imagemAtual.url.startsWith('blob:')) {
    URL.revokeObjectURL(imagemAtual.url)
  }

  // ✅ remove direto na referência (mais confiável)
  imagensPorPosicao.value[posicao] = {
    file: null,
    url: null
  }

  // ✅ força reatividade (ESSENCIAL no seu caso)
  imagensPorPosicao.value = { ...imagensPorPosicao.value }

  // ✅ atualiza draft
  institutionalStore.imagensDraft = getImagensSemUpload()
}


// FIM

const getPosicoesAtivas = () => {
  const posicoes: number[] = []

  if (alterarTelaInicial.value === 'sim') {
    posicoes.push(...POSICOES_TELA_INICIAL)
  }

  if (alterarTelaAguarde.value === 'sim') {
    posicoes.push(...POSICOES_TELA_AGUARDE)
  }

  if (alterarTelaAbertura.value === 'sim') {
    posicoes.push(...POSICOES_TELA_ABERTURA)
  }

  return posicoes
}

/* =========================================================
 * ESTADOS AUXILIARES
 * ======================================================= */
const alterarTelaInicial = ref('sim');
const corTexto = ref<string | null>(null);
const tempoExibicaoDummy = ref<string | null>(null);
const alterarTelaAguarde = ref('sim');
const alterarTelaAbertura = ref('sim');
const apresentaParaCliente = ref('nao');
const usuarioInteragiu = ref(false);
const ultimoIdCarregado = ref<number | null>(null);
const usuarioAlterouApresentacao = ref(false);
const usuarioAlterouTelaAbertura = ref(false);
const usuarioAlterouCorTexto = ref(false);

watchEffect(() => {
  if (!props.accordionsData) return

  const novoId = props.accordionsData.id ?? null

  if (ultimoIdCarregado.value !== novoId) {
    usuarioInteragiu.value = false
    usuarioAlterouApresentacao.value = false
    usuarioAlterouTelaAbertura.value = false
    usuarioAlterouCorTexto.value = false
    ultimoIdCarregado.value = novoId
  }

  if (!usuarioInteragiu.value) {
    telasIniciais.value = (props.accordionsData.telasIniciais || []).map((t: any) => ({
      ...t,
      tempo: t.tempo !== undefined && t.tempo !== null ? t.tempo : 10
    }))
  }

  telasAtm.value = props.accordionsData.telasAtm || []
  telasAguardeGeral.value = props.accordionsData.telasAguardeGeral || []
  telasAguardeChip.value = props.accordionsData.telasAguardeChip || []
  telasAbertura.value = props.accordionsData.telasAbertura || []

  const temDraft = institutionalStore.imagensDraft.length > 0

  const imagensFonte =
    props.mode === 'view'
      ? (props.accordionsData.imagens || [])
      : (
          temDraft
            ? institutionalStore.imagensDraft
            : (props.accordionsData.imagens || [])
        )

  const novasImagens = { ...imagensPorPosicao.value }

 imagensFonte.forEach((img: any) => {
    novasImagens[img.posicaoImagem] = {
      file: img.file ?? null,
      url: img.urlPreview ?? img.urlS3 ?? null
    }
  })

  imagensPorPosicao.value = novasImagens

  // VOLTAR
  /*if (!usuarioInteragiu.value && props.accordionsData) {
    // ✅ Se não tem imagem, força "não"
    if (!temImagemTelaInicial.value) {
      alterarTelaInicial.value = 'nao'
    } else {
      alterarTelaInicial.value =
        props.accordionsData.alterarTelaInicial ? 'sim' : 'nao'
    }

    // ✅ Se não tem imagem, força "não"
    if (!temImagemTelaAguarde.value) {
      alterarTelaAguarde.value = 'nao'
    } else {
      alterarTelaAguarde.value =
        props.accordionsData.alterarTelaAguarde ? 'sim' : 'nao'
    }

    alterarTelaAbertura.value =
      props.accordionsData.alterarTelaAbertura ? 'sim' : 'sim'
  } */

 if (!usuarioInteragiu.value && props.accordionsData) {
  if (props.mode === 'view') {
    // ✅ VIEW: força "não" se não tem imagem
    alterarTelaInicial.value = !temImagemTelaInicial.value ? 'nao' : 'sim'
    alterarTelaAguarde.value = !temImagemTelaAguarde.value ? 'nao' : 'sim'
  } else {
    // ✅ EDIT: respeita o que foi selecionado antes
    
// if (temImagemTelaInicial.value) {
//   alterarTelaInicial.value = 'sim'
// } else {
//   alterarTelaInicial.value = 'nao'
// }


   
// if (temImagemTelaAguarde.value) {
//   alterarTelaAguarde.value = 'sim'
// } else {
//   alterarTelaAguarde.value = 'nao'
// }

    alterarTelaInicial.value = 'sim'
    alterarTelaAguarde.value = 'sim'
    alterarTelaAbertura.value = 'sim'

  }

  // alterarTelaAbertura.value =
  //   props.accordionsData.alterarTelaAbertura ? 'sim' : 'sim'
}

  const corRecebida = props.accordionsData?.corTexto ?? null

  console.log('[Accordion] mode:', props.mode)
  console.log('[Accordion] corTexto vindo da View:', props.accordionsData?.corTexto)
  console.log('[Accordion] corRecebida final:', corRecebida)

  if (props.mode === 'view') {
    corTexto.value = corRecebida
  } else if (!usuarioAlterouCorTexto.value) {
    corTexto.value = corRecebida
  }

  console.log(props.accordionsData)

  console.log('[Accordion] corTexto setado no state:', corTexto.value)

  if (!usuarioAlterouApresentacao.value) {
    apresentaParaCliente.value =
      props.accordionsData?.exibeTelaAbertura ? 'sim' : 'nao'
  }
})

/*watchEffect(() => {
  if (!props.accordionsData) return

  const novoId = props.accordionsData.id ?? null

  if (ultimoIdCarregado.value !== novoId) {
    usuarioInteragiu.value = false
    usuarioAlterouApresentacao.value = false
    usuarioAlterouTelaAbertura.value = false
    usuarioAlterouCorTexto.value = false
    ultimoIdCarregado.value = novoId
  }

  telasIniciais.value = (props.accordionsData.telasIniciais || []).map((t: any) => ({
    ...t,
    tempo: t.tempo ?? 10
  }))

  telasAtm.value = props.accordionsData.telasAtm || []
  telasAguardeGeral.value = props.accordionsData.telasAguardeGeral || []
  telasAguardeChip.value = props.accordionsData.telasAguardeChip || []
  telasAbertura.value = props.accordionsData.telasAbertura || []

  if (!usuarioInteragiu.value) {
    resetImagens()

    const imagensFonte =
      props.mode === 'view'
        ? (props.accordionsData.imagens || [])
        : (
            institutionalStore.imagensDraft.length > 0
              ? institutionalStore.imagensDraft
              : (props.accordionsData.imagens || [])
          )

    imagensFonte.forEach((img: any) => {
      imagensPorPosicao.value[img.posicaoImagem] = {
        file: img.file ?? null,
        url: img.urlPreview ?? img.urlS3 ?? null
      }
    })
  }

  // if (!usuarioInteragiu.value) {
  //   const temImagemInicial =
  //     POSICOES_TELA_INICIAL.some(pos => imagensPorPosicao.value[pos]?.url)

  //   const temImagemAguarde =
  //     POSICOES_TELA_AGUARDE.some(pos => imagensPorPosicao.value[pos]?.url)

  //   const temImagemAbertura =
  //     POSICOES_TELA_ABERTURA.some(pos => imagensPorPosicao.value[pos]?.url)

    

  //   // ✅ regra importante (igual backend espera)
  //   const exibeTelaAbertura =
  //     props.accordionsData?.exibeTelaAbertura ??
  //     institutionalStore.institutionalDetail?.exibeTelaAbertura

    
  // };

  if (!usuarioInteragiu.value && props.accordionsData) {
    alterarTelaInicial.value =
      props.accordionsData.alterarTelaInicial ? 'sim' : 'nao'

    alterarTelaAguarde.value =
      props.accordionsData.alterarTelaAguarde ? 'sim' : 'nao'

    alterarTelaAbertura.value =
      props.accordionsData.alterarTelaAbertura ? 'sim' : 'nao'
  }

  const corRecebida = props.accordionsData?.corTexto ?? null

  console.log('[Accordion] mode:', props.mode)
  console.log('[Accordion] corTexto vindo da View:', props.accordionsData?.corTexto)
  console.log('[Accordion] corRecebida final:', corRecebida)

  if (props.mode === 'view') {
    corTexto.value = corRecebida
  } else if (!usuarioAlterouCorTexto.value) {
    corTexto.value = corRecebida
  }

  console.log(props.accordionsData)

  console.log('[Accordion] corTexto setado no state:', corTexto.value)

  if (!usuarioAlterouApresentacao.value) {
    apresentaParaCliente.value =
      props.accordionsData?.exibeTelaAbertura ? 'sim' : 'nao'
  }
}) */

// watch(alterarTelaInicial, (novoValor, valorAnterior) => {
//   if (novoValor === valorAnterior) return

//   usuarioInteragiu.value = true

//   if (novoValor === 'nao') {
//     limparPosicoes(POSICOES_TELA_INICIAL)
//     corTexto.value = null
//     usuarioAlterouCorTexto.value = true
//   }
// })

watch(alterarTelaInicial, (novoValor, valorAnterior) => {
  if (novoValor === valorAnterior) return

  usuarioInteragiu.value = true

  // ✅ SÓ limpa se o usuário realmente mudou para "não"
  if (valorAnterior === 'sim' && novoValor === 'nao') {
    limparPosicoes(POSICOES_TELA_INICIAL)
    corTexto.value = null
    usuarioAlterouCorTexto.value = true
  }
})

watch(alterarTelaAguarde, (novoValor, valorAnterior) => {
  if (novoValor === valorAnterior) return

  usuarioInteragiu.value = true

  if (novoValor === 'nao') {
    limparPosicoes(POSICOES_TELA_AGUARDE)
  }
})

watch(alterarTelaAbertura, (novoValor, valorAnterior) => {
  if (novoValor === valorAnterior) return

  usuarioInteragiu.value = true
  usuarioAlterouTelaAbertura.value = true

  if (novoValor === 'nao') {
    limparPosicoes(POSICOES_TELA_ABERTURA)
    apresentaParaCliente.value = 'nao'
    usuarioAlterouApresentacao.value = true
  }
})

watch(apresentaParaCliente, (novoValor, valorAnterior) => {
  if (novoValor === valorAnterior) return

  usuarioInteragiu.value = true
  usuarioAlterouApresentacao.value = true

  if (novoValor === 'nao') {
    limparPosicoes(POSICOES_TELA_ABERTURA)
  }
})

watch(apresentaParaCliente, (novoValor, valorAnterior) => {
  if (novoValor === valorAnterior) return

  usuarioInteragiu.value = true
  usuarioAlterouApresentacao.value = true

  if (valorAnterior === 'sim' && novoValor === 'nao') {
    removerImagem(5)
  }
})



/* =========================================================
 * COLUNAS DAS TABELAS
 * ======================================================= */
const telaColumns = computed<QTableColumn<TelaInicialRow>[]>(() => {
  const baseColumns: QTableColumn<TelaInicialRow>[] = [
    {
      name: 'tela',
      label: 'Tela',
      field: 'tela',
      align: 'left',
      style: 'width: 220px',
      headerStyle: 'width: 220px'
    },
    { name: 'imagem', label: 'Imagem', field: row => row, align: 'center' },
    {
      name: 'ordem',
      label: 'Ordem da imagem',
      field: 'ordem',
      align: 'center',
      style: 'width: 110px',
      headerStyle: 'width: 110px; text-align: center',
    },
    {
      name: 'tempo',
      label: 'Tempo de exibição',
      field: 'tempo',
      align: 'center',
      style: 'width: 130px',
      headerStyle: 'width: 130px; text-align: center',
    },
    {
      name: 'upload',
      label: 'Importar',
      field: () => null,
      align: 'center',
      style: 'width: 120px',
      headerStyle: 'width: 120px; text-align: center',
    }
  ]

  if (isViewMode.value) {
    baseColumns.splice(2, 0, {
      name: 'download',
      label: 'Download',
      field: () => null,
      align: 'center',
      style: 'width: 80px',
      headerStyle: 'width: 80px; text-align: center'
    })
  }

  return baseColumns
})

const buttonsColumns = computed<QTableColumn<TelaAtmRow>[]>(() => {
  const baseColumns: QTableColumn<TelaAtmRow>[] = [
    {
      name: 'botao',
      label: 'Botões',
      field: 'botao',
      align: 'left',
      style: 'width: 200px',
      headerStyle: 'width: 200px'
    },

    { name: 'imagem', label: 'Imagem', field: row => row, align: 'center' },
    {
      name: 'upload',
      label: 'Importar',
      field: () => null,
      align: 'center',
      style: 'width: 120px',
      headerStyle: 'width: 120px; text-align: center',
    },
  ]

  if (isViewMode.value) {
    baseColumns.splice(2, 0, {
      name: 'download',
      label: 'Download',
      field: () => null,
      align: 'center',
      style: 'width: 80px',
      headerStyle: 'width: 80px; text-align: center'
    })
  }

  return baseColumns
})

const aguardeColumns = computed<QTableColumn<TelaAguardeRow>[]>(() => {
  const baseColumns: QTableColumn<TelaAguardeRow>[] = [
    {
      name: 'tela',
      label: 'Tela',
      field: 'tela',
      align: 'left',
      style: 'width: 210px',
      headerStyle: 'width: 210px'
    },
    { name: 'imagem', label: 'Imagem', field: row => row, align: 'center' },
    {
      name: 'upload',
      label: 'Importar',
      field: () => null,
      align: 'center',
      style: 'width: 120px',
      headerStyle: 'width: 120px; text-align: center',
    },
  ];

  if (isViewMode.value) {
    baseColumns.splice(2, 0, {
      name: 'download',
      label: 'Download',
      field: () => null,
      align: 'center',
      style: 'width: 80px',
      headerStyle: 'width: 80px; text-align: center'
    });
  }

  return baseColumns;
});

const aberturaColumns = computed<QTableColumn<TelaAberturaRow>[]>(() => {
  const baseColumns: QTableColumn<TelaAberturaRow>[] = [
    {
      name: 'tela',
      label: 'Tela',
      field: 'tela',
      align: 'left',
      style: 'width: 200px',
      headerStyle: 'width: 200px'
    },
    { name: 'imagem', label: 'Imagem', field: row => row, align: 'center' },
    {
      name: 'upload',
      label: 'Importar',
      field: () => null,
      align: 'center',
      style: 'width: 120px',
      headerStyle: 'width: 120px; text-align: center',
    },
  ];

  if (isViewMode.value) {
    baseColumns.splice(2, 0, {
      name: 'download',
      label: 'Download',
      field: () => null,
      align: 'center',
      style: 'width: 80px',
      headerStyle: 'width: 80px; text-align: center'
    });
  }

  return baseColumns;
});

const safeTelasAguardeGeral = computed(() => telasAguardeGeral.value ?? []);
const safeTelasAguardeChip = computed(() => telasAguardeChip.value ?? []);
const safeTelasAbertura = computed(() => telasAbertura.value ?? []);

/* =========================================================
 * 🆕 UPLOAD COM MAPEAMENTO DE POSIÇÕES
 * ======================================================= */
// const moveUp = (index: number) => {
//   if (index <= 0) return

//   const arr = [...telasIniciais.value]
  
//   // ✅ Troca apenas tempo entre as posições
//   const tempoTemp = arr[index].tempo
//   arr[index].tempo = arr[index - 1].tempo
//   arr[index - 1].tempo = tempoTemp

//   // ✅ Troca as imagens entre as posições
//   trocarImagens(arr[index].posicao, arr[index - 1].posicao)

//   telasIniciais.value = arr
//   institutionalStore.imagensDraft = getImagensSemUpload()
// }
const moveUp = (index: number) => {
  if (index <= 0) return

  const arr = [...telasIniciais.value]

  // ✅ troca tempo
  const tempoTemp = arr[index].tempo
  arr[index].tempo = arr[index - 1].tempo
  arr[index - 1].tempo = tempoTemp

  // ✅ troca ORDEM (ESSENCIAL)
  const ordemTemp = arr[index].ordem
  arr[index].ordem = arr[index - 1].ordem
  arr[index - 1].ordem = ordemTemp

  // ✅ troca imagem
  trocarImagens(arr[index].posicao, arr[index - 1].posicao)

  telasIniciais.value = arr
  institutionalStore.imagensDraft = getImagensSemUpload()
}

// const moveDown = (index: number) => {
//   if (index >= telasIniciais.value.length - 1) return

//   const arr = [...telasIniciais.value]
  
//   // ✅ Troca apenas tempo entre as posições
//   const tempoTemp = arr[index].tempo
//   arr[index].tempo = arr[index + 1].tempo
//   arr[index + 1].tempo = tempoTemp

//   // ✅ Troca as imagens entre as posições
//   trocarImagens(arr[index].posicao, arr[index + 1].posicao)

//   telasIniciais.value = arr
//   institutionalStore.imagensDraft = getImagensSemUpload()
// }
const moveDown = (index: number) => {
  if (index >= telasIniciais.value.length - 1) return

  const arr = [...telasIniciais.value]

  // ✅ troca tempo
  const tempoTemp = arr[index].tempo
  arr[index].tempo = arr[index + 1].tempo
  arr[index + 1].tempo = tempoTemp

  // ✅ troca ORDEM (ESSENCIAL)
  const ordemTemp = arr[index].ordem
  arr[index].ordem = arr[index + 1].ordem
  arr[index + 1].ordem = ordemTemp

  // ✅ troca imagem
  trocarImagens(arr[index].posicao, arr[index + 1].posicao)

  telasIniciais.value = arr
  institutionalStore.imagensDraft = getImagensSemUpload()
}

// ✅ função auxiliar que troca imagens entre duas posições
const trocarImagens = (posA: number, posB: number) => {
  const imgA = { ...imagensPorPosicao.value[posA] }
  const imgB = { ...imagensPorPosicao.value[posB] }

  // ✅ substitui o objeto inteiro para forçar reatividade do Vue
  imagensPorPosicao.value = {
    ...imagensPorPosicao.value,
    [posA]: imgB,
    [posB]: imgA
  }
}



const fileInput = ref<HTMLInputElement | null>(null);
const uploadingPosicao = ref<number | null>(null);

const onUploadClick = (posicao: number) => {
  if (isViewMode.value) return;
  
  uploadingPosicao.value = posicao;
  fileInput.value?.click();
};

/*const validarImagem = (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    // ✅ 1. Validar formato
    const formatosPermitidos = ['image/webp', 'image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
    
    if (!formatosPermitidos.includes(file.type)) {
      $q.notify({
        type: 'negative',
        message: 'Formato inválido. Use: webp, jpg, png, jpeg ou gif',
        position: 'top'
      });
      resolve(false);
      return;
    }

    // ✅ 2. Validar tamanho (máximo 500kb)
    const tamanhoMaximo = 500 * 1024; // 500kb em bytes
    if (file.size > tamanhoMaximo) {
      $q.notify({
        type: 'negative',
        message: `Imagem muito grande. Máximo: 500kb. Tamanho atual: ${(file.size / 1024).toFixed(2)}kb`,
        position: 'top'
      });
      resolve(false);
      return;
    }
    

    // ✅ 3. Validar dimensões (640x480)
    const img = new Image();
    img.onload = () => {
      const larguraEsperada = 640;
      const alturaEsperada = 480;

      if (img.width !== larguraEsperada || img.height !== alturaEsperada) {
        $q.notify({
          type: 'negative',
          message: `Dimensão inválida. Esperado: ${larguraEsperada}x${alturaEsperada}px. Recebido: ${img.width}x${img.height}px`,
          position: 'top'
        });
        resolve(false);
      } else {
        resolve(true);
      }
    };

    img.onerror = () => {
      $q.notify({
        type: 'negative',
        message: 'Erro ao validar imagem. Verifique se o arquivo é uma imagem válida.',
        position: 'top'
      });
      resolve(false);
    };

    img.src = URL.createObjectURL(file);
  });
};*/

const validarImagem = (file: File, posicao: number): Promise<boolean> => {
  return new Promise((resolve) => {
    // ✅ 1. Validar formato
    const formatosPermitidos = ['image/webp', 'image/jpg', 'image/jpeg', 'image/png', 'image/gif']

    if (!formatosPermitidos.includes(file.type)) {
      $q.notify({ type: 'negative', message: 'Formato inválido. Use: webp, jpg, png, jpeg ou gif', position: 'top' })
      resolve(false)
      return
    }

    // ✅ 2. Validar tamanho (máximo 500kb)
    const tamanhoMaximo = 500 * 1024
    if (file.size > tamanhoMaximo) {
      $q.notify({
        type: 'negative',
        message: `Imagem muito grande. Máximo: 500kb. Tamanho atual: ${(file.size / 1024).toFixed(2)}kb`,
        position: 'top'
      })
      resolve(false)
      return
    }

    // ✅ 3. Dimensões — botões ATM têm dimensão diferente
    const posicoesBotoes = [8, 9, 10, 11]
    const isBotao = posicoesBotoes.includes(posicao)

    const larguraEsperada = isBotao ? 257 : 640
    const alturaEsperada  = isBotao ? 50  : 480

    // const img = new Image()
    // img.onload = () => {
    //   if (img.width !== larguraEsperada || img.height !== alturaEsperada) {
    //     $q.notify({
    //       type: 'negative',
    //       message: `Dimensão inválida. Esperado: ${larguraEsperada}x${alturaEsperada}px. Recebido: ${img.width}x${img.height}px`,
    //       position: 'top'
    //     })
    //     resolve(false)
    //   } else {
    //     resolve(true)
    //   }
    // }

    const img = new Image()
    img.onload = () => {
      resolve(true)
    }

    img.onerror = () => {
      $q.notify({
        type: 'negative',
        message: 'Erro ao validar imagem.',
        position: 'top'
      })
      resolve(false)
    }

    // img.onerror = () => {
    //   $q.notify({ type: 'negative', message: 'Erro ao validar imagem.', position: 'top' })
    //   resolve(false)
    // }

    img.src = URL.createObjectURL(file)
  })
}

// const onFileSelected = async (event: Event) => {
//   if (isViewMode.value) return

//   const input = event.target as HTMLInputElement
//   if (!input.files || !input.files[0] || uploadingPosicao.value === null) return

//   const file = input.files[0]
//   const posicao = uploadingPosicao.value

//   const isValid = await validarImagem(file, posicao)

//   if (!isValid) {
//     input.value = ''
//     uploadingPosicao.value = null
//     return
//   }

//   usuarioInteragiu.value = true

//   const oldUrl = imagensPorPosicao.value[posicao]?.url
//   if (oldUrl) {
//     URL.revokeObjectURL(oldUrl)
//   }

//   imagensPorPosicao.value = {
//     ...imagensPorPosicao.value,
//     [posicao]: {
//       file: file,
//       url: URL.createObjectURL(file)
//     }
//   }

//   input.value = ''
//   uploadingPosicao.value = null
// }

const onFileSelected = async (event: Event) => {
  if (isViewMode.value) return

  const input = event.target as HTMLInputElement
  if (!input.files || !input.files[0] || uploadingPosicao.value === null) return

  const file = input.files[0]
  const posicao = uploadingPosicao.value

  // ✅ VALIDAÇÃO DO NOME DO ARQUIVO
  const nomeArquivo = file.name
  const nomeValido = /^[a-zA-Z0-9._-]+$/.test(nomeArquivo)

  if (!nomeValido) {
    $q.notify({
      type: 'negative',
      message: 'Nome do arquivo inválido. Não utilize acentos, espaços ou caracteres especiais.',
      position: 'top',
      timeout: 5000
    })

    input.value = ''
    uploadingPosicao.value = null
    return
  }

  // ✅ VALIDAÇÃO DE DIMENSÃO/TIPO
  const isValid = await validarImagem(file, posicao)

  if (!isValid) {
    input.value = ''
    uploadingPosicao.value = null
    return
  }

  usuarioInteragiu.value = true

  const oldUrl = imagensPorPosicao.value[posicao]?.url
  if (oldUrl) {
    URL.revokeObjectURL(oldUrl)
  }

  imagensPorPosicao.value = {
    ...imagensPorPosicao.value,
    [posicao]: {
      file: file,
      url: URL.createObjectURL(file)
    }
  }

  
// ✅ manter draft sincronizado
institutionalStore.imagensDraft = getImagensSemUpload()

  input.value = ''
  uploadingPosicao.value = null
}


/* =========================================================
 * 🆕 FUNÇÃO DE UPLOAD PARA S3 (Node.js)
 * ======================================================= */
// const uploadImagensParaS3 = async () => {
//   // Filtra apenas posições com imagem
//   const posicoesComImagem = Object.entries(imagensPorPosicao.value)
//     .filter(([_, data]) => data.file !== null)
//     .sort(([posA], [posB]) => parseInt(posA) - parseInt(posB));

//   if (posicoesComImagem.length === 0) {
//     throw new Error('Nenhuma imagem selecionada');
//   }

//   const formData = new FormData();
//   const mapeamentoPosicoes: number[] = [];

//   posicoesComImagem.forEach(([posicao, data]) => {
//     if (data.file) {
//       formData.append('images', data.file);
//       mapeamentoPosicoes.push(parseInt(posicao));
//     }
//   });

//   console.log('📤 Enviando imagens para S3. Posições:', mapeamentoPosicoes);

//   const response = await fetch('http://localhost:3000/uploadTelasATMImages', {
//     method: 'POST',
//     body: formData
//   });

//   const resultado = await response.json();

//   if (!resultado.success) {
//     throw new Error(resultado.error || 'Erro no upload');
//   }

  
// const getDuracaoPorPosicao = (pos: number) => {
//   const telaInicial = telasIniciais.value.find(t => t.posicao === pos);
//   if (telaInicial) return telaInicial.tempo;

//   // ✅ fallback (se quiser tratar outros tipos depois)
//   return telaInicial?.tempo ?? 1 ;
// };

//   // Mapeia URLs retornadas para posições corretas
//  /* const imagensComPosicaoCorreta = resultado.uploadLocations.map((item: any, index: number) => ({
//     posicaoImagem: mapeamentoPosicoes[index],
//     urlS3: item.url,
//     duracaoImagem: 5 // ou pegar do formulário
//   }));*/

  
// const imagensComPosicaoCorreta = resultado.uploadLocations.map((item: any, index: number) => {
//   const posicao = mapeamentoPosicoes[index];

//   return {
//     posicaoImagem: posicao,
//     urlS3: item.url,

//     // ✅ AQUI É A CORREÇÃO REAL
//     duracaoImagem: getDuracaoPorPosicao(posicao)
//   };
// });


//   console.log('Upload concluído:', imagensComPosicaoCorreta);

//   return imagensComPosicaoCorreta;
// };

const uploadImagensParaS3 = async () => {
  const posicoesAtivas = getPosicoesAtivas()

  const posicoesComImagem = Object.entries(imagensPorPosicao.value)
    .filter(([posicao, data]) => {
      const pos = Number(posicao)
      return posicoesAtivas.includes(pos) && data.file !== null
    })
    .sort(([posA], [posB]) => parseInt(posA) - parseInt(posB))

  if (posicoesComImagem.length === 0) {
    return []
  }

  const formData = new FormData()
  const mapeamentoPosicoes: number[] = []

  posicoesComImagem.forEach(([posicao, data]) => {
    if (data.file) {
      formData.append('images', data.file)
      mapeamentoPosicoes.push(parseInt(posicao))
    }
  })

  console.log('📤 Enviando imagens para S3. Posições:', mapeamentoPosicoes)

  const response = await fetch('http://localhost:3000/uploadTelasATMImages', {
    method: 'POST',
    body: formData
  })

  const resultado = await response.json()

  if (!resultado.success) {
    throw new Error(resultado.error || 'Erro no upload')
  }

  const getDuracaoPorPosicao = (pos: number) => {
    const telaInicial = telasIniciais.value.find(t => t.posicao === pos)
    if (telaInicial) return telaInicial.tempo
    return 1
  }

  const imagensComPosicaoCorreta = resultado.uploadLocations.map((item: any, index: number) => {
    const posicao = mapeamentoPosicoes[index]

    return {
      posicaoImagem: posicao,
      urlS3: item.url,
      duracaoImagem: getDuracaoPorPosicao(posicao)
    }
  })

  console.log('Upload concluído:', imagensComPosicaoCorreta)

  return imagensComPosicaoCorreta
}

// const getImagensSemUpload = () => {
//   return Object.entries(imagensPorPosicao.value)
//     .filter(([_, data]) => data.file !== null || data.url !== null) // ✅ inclui existentes
//     .map(([posicao, data]) => {
//       const pos = Number(posicao);
//       const tela = telasIniciais.value.find(t => t.posicao === pos);

//       return {
//         posicaoImagem: pos,
//         file: data.file,                          // null se não trocou
//         urlS3: data.file ? null : data.url,       // ✅ preserva url do backend
//         urlPreview: data.url,
//         duracaoImagem: tela?.tempo ?? 1
//       };
//     });
// };

const getImagensSemUpload = () => {
  const posicoesAtivas = getPosicoesAtivas()

  return Object.entries(imagensPorPosicao.value)
    .filter(([posicao, data]) => {
      const pos = Number(posicao)
      return posicoesAtivas.includes(pos) && (data.file !== null || data.url !== null)
    })
    .map(([posicao, data]) => {
      const pos = Number(posicao)
      const tela = telasIniciais.value.find(t => t.posicao === pos)

      return {
        posicaoImagem: pos,
        file: data.file,
        urlS3: data.file ? null : data.url,
        urlPreview: data.url,
        duracaoImagem: tela?.tempo ?? 1
      }
    })
}

/* =========================================================
 * 🆕 FUNÇÃO PARA OBTER DADOS COMPLETOS (para enviar ao backend)
 * ======================================================= */
const obterDadosCompletos = async () => {
  try {
    // ✅ 1. VALIDAR TUDO ANTES DE FAZER UPLOAD
    const validacao = validarTodosCadastro(
      alterarTelaInicial.value,
      alterarTelaAguarde.value,
      alterarTelaAbertura.value,
      apresentaParaCliente.value,
      telasIniciais.value,
      imagensPorPosicao.value
    );

    if (!validacao.valido) {
      // ✅ Mostrar TODAS as mensagens de erro de uma vez
      const mensagensErro = (validacao.mensagens || []).join('\n');
      
      $q.notify({
        type: 'negative',
        message: mensagensErro,
        position: 'top',
        timeout: 5000
      });
      
      throw new Error(mensagensErro);
    }

    // ✅ 2. FAZER UPLOAD DAS IMAGENS
    const imagensComPosicao = await uploadImagensParaS3();

    
    return {
      imagens: imagensComPosicao
      // Outros dados do formulário virão daqui
    };
  } catch (error) {
    console.error('❌ Erro ao processar imagens:', error);
    throw error;
  }
};

// const getTelasSeleccionadas = () => {
//   const telas: any[] = []

//   // Posições por tipo de tela
//   const posicoesIniciais = [1, 2, 3, 4]
//   const posicoesAtm = [8, 9, 10, 11]
//   const posicoesAguarde = [6, 7]
//   const posicoesAbertura = [5]

//   const temImagem = (posicoes: number[]) =>
//     posicoes.some(pos => imagensPorPosicao.value[pos]?.url)

//   // ✅ só adiciona se tiver imagem configurada naquelas posições
//   if (alterarTelaInicial.value === 'sim' && temImagem([...posicoesIniciais, ...posicoesAtm])) {
//     telas.push({ tipoTela: 'INICIAL' })
//   }

//   if (alterarTelaAguarde.value === 'sim' && temImagem(posicoesAguarde)) {
//     telas.push({ tipoTela: 'AGUARDE' })
//   }

//   if (alterarTelaAbertura.value === 'sim' && temImagem(posicoesAbertura)) {
//     telas.push({
//       tipoTela: 'ABERTURA',
//       apresentaParaCliente: apresentaParaCliente.value === 'sim'
//     })
//   }

//   return telas
// }

const getTelasSelecionadas = () => {
  const telas: any[] = []

  const posicoesIniciais = [1, 2, 3, 4]
  const posicoesAtm = [8, 9, 10, 11]
  const posicoesAguarde = [6, 7]

  const temImagem = (posicoes: number[]) =>
    posicoes.some(pos => imagensPorPosicao.value[pos]?.url)

  // INICIAL
  if (alterarTelaInicial.value === 'sim' && (temImagem([...posicoesIniciais, ...posicoesAtm]) || corTexto.value)) {
    telas.push({ tipoTela: 'INICIAL' })
  }

  // AGUARDE
  if (alterarTelaAguarde.value === 'sim' && temImagem(posicoesAguarde)) {
    telas.push({ tipoTela: 'AGUARDE' })
  }

  // ABERTURA
  // ✅ agora entra sempre que houver configuração da tela de abertura,
  // mesmo sem imagem
  /*if (alterarTelaAbertura.value === 'sim') {
    telas.push({
      tipoTela: 'ABERTURA',
      apresentaParaCliente: apresentaParaCliente.value === 'sim'
    })
  }*/
 
// ✅ ABERTURA (SEMPRE)
  telas.push({
    tipoTela: 'ABERTURA',
    apresentaParaCliente: apresentaParaCliente.value === 'sim'
  })


  return telas
}

// const getImagensCompletas = () => {
//   return Object.entries(imagensPorPosicao.value).map(
//     ([posicao, data]) => ({
//       posicaoImagem: Number(posicao),
//       file: data.file,
//       url: data.url
//     })
//   )
// }

const getImagensCompletas = () => {
  const posicoesAtivas = getPosicoesAtivas()

  return Object.entries(imagensPorPosicao.value)
    .filter(([posicao]) => posicoesAtivas.includes(Number(posicao)))
    .map(([posicao, data]) => ({
      posicaoImagem: Number(posicao),
      file: data.file,
      url: data.url
    }))
}


/* =========================================================
 * PREVIEW E DOWNLOAD
 * ======================================================= */
const previewAberto = ref(false)
const previewUrl = ref<string>('')

const abrirPreview = (url: string) => {
  previewUrl.value = url
  previewAberto.value = true
}

/*const downloadImagem = async (url: string) => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = url.split('/').pop() || 'imagem'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(blobUrl) // ✅ libera memória
  } catch (error) {
    // ✅ fallback se CORS bloquear o fetch também
    window.open(url, '_blank')
  }
}*/

const downloadImagem = async (url: string) => {
  try {
    if (url.startsWith('blob:')) {
      const link = document.createElement('a')
      link.href = url
      //link.download = 'imagem.png'
      link.download = url.split('/').pop() || 'imagem'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      return
    }

    const response = await fetch(url)
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = url.split('/').pop() || 'imagem'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    window.open(url, '_blank')
  }
}


// Expor função para componente pai
__expose({
  obterDadosCompletos,
  getImagensSemUpload,
  getTelasSelecionadas,
  getImagensCompletas,

  getAlterarTelaAbertura: () => alterarTelaAbertura.value === 'sim',

  getExibeTelaAbertura: () => {
    if (alterarTelaAbertura.value !== 'sim') {
      return false
    }
    return apresentaParaCliente.value === 'sim'
  },

  // getCorTexto: () => {
  //   if (alterarTelaInicial.value !== 'sim') {
  //     return null
  //   }
  //   return corTexto.value
  // }

  getCorTexto: () => {
  return corTexto.value
},
  getApresentaParaCliente: () => apresentaParaCliente.value === 'sim'
});

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_expansion_item, {
      "expand-separator": "",
      icon: "menu",
      label: "Telas Iniciais",
      class: "accordion-item"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          true
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Cor Texto - Notas Disponíveis", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("input", {
                      type: "color",
                      value: corTexto.value ?? '#000000',
                      disabled: isViewMode.value,
                      onInput: _cache[0] || (_cache[0] = (e) => { corTexto.value = (e.target as HTMLInputElement).value; usuarioAlterouCorTexto.value = true }),
                      style: {"width":"48px","height":"48px","padding":"2px","border":"1px solid #ccc","border-radius":"4px","cursor":"pointer"}
                    }, null, 40, _hoisted_5),
                    _createVNode(_component_q_input, {
                      modelValue: corTexto.value,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((corTexto).value = $event)),
                        _cache[2] || (_cache[2] = ($event: any) => (usuarioAlterouCorTexto.value = true))
                      ],
                      outlined: "",
                      dense: "",
                      label: "",
                      style: {"width":"130px"},
                      readonly: isViewMode.value,
                      clearable: "",
                      onClear: _cache[3] || (_cache[3] = () => { corTexto.value = null; usuarioAlterouCorTexto.value = true })
                    }, null, 8, ["modelValue", "readonly"])
                  ])
                ]),
                _createVNode(_component_q_table, {
                  flat: "",
                  dense: "",
                  "hide-pagination": "",
                  rows: telasIniciais.value,
                  columns: telaColumns.value,
                  "row-key": "id",
                  "table-class": "institutional-table",
                  "table-style": "min-width: 100%"
                }, {
                  "body-cell-imagem": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          (imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("img", {
                                  src: imagensPorPosicao.value[props.row.posicao].url,
                                  style: {"width":"60px","height":"60px","object-fit":"cover","border-radius":"4px","cursor":"pointer"},
                                  alt: "Preview",
                                  onClick: ($event: any) => (abrirPreview(imagensPorPosicao.value[props.row.posicao].url!))
                                }, null, 8, _hoisted_8),
                                (!isViewMode.value)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      icon: "close",
                                      color: "negative",
                                      dense: "",
                                      flat: "",
                                      round: "",
                                      size: "sm",
                                      onClick: ($event: any) => (removerImagem(props.row.posicao))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Sem imagem"))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-download": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          (isViewMode.value && imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                icon: "download",
                                color: "primary",
                                dense: "",
                                round: "",
                                onClick: ($event: any) => (downloadImagem(imagensPorPosicao.value[props.row.posicao].url as string))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-ordem": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_q_btn, {
                            flat: "",
                            dense: "",
                            icon: "arrow_upward",
                            size: "sm",
                            disable: isViewMode.value || props.rowIndex === 0,
                            onClick: ($event: any) => (moveUp(props.rowIndex))
                          }, null, 8, ["disable", "onClick"]),
                          _createVNode(_component_q_btn, {
                            flat: "",
                            dense: "",
                            icon: "arrow_downward",
                            size: "sm",
                            disable: isViewMode.value || props.rowIndex === telasIniciais.value.length - 1,
                            onClick: ($event: any) => (moveDown(props.rowIndex))
                          }, null, 8, ["disable", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-tempo": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_q_select, {
                            modelValue: props.row.tempo,
                            "onUpdate:modelValue": [($event: any) => ((props.row.tempo) = $event), (val) => props.row.tempo = val],
                            dense: "",
                            outlined: "",
                            options: _unref(opcoesTempoExibicao),
                            style: {"width":"60px"},
                            disable: isViewMode.value
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disable"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-upload": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            dense: "",
                            "no-caps": "",
                            icon: "upload",
                            label: "Upload",
                            disable: isViewMode.value,
                            onClick: ($event: any) => (onUploadClick(props.row.posicao))
                          }, null, 8, ["disable", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns"]),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "midia-app-caption-sm q-mb-sm block q-mt-lg" }, " Configuração Telas ATM ", -1)),
                _createVNode(_component_q_table, {
                  flat: "",
                  dense: "",
                  "hide-pagination": "",
                  rows: telasAtm.value,
                  columns: buttonsColumns.value,
                  "row-key": "id",
                  "table-class": "institutional-table"
                }, {
                  "body-cell-imagem": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          (imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("img", {
                                  src: imagensPorPosicao.value[props.row.posicao].url,
                                  style: {"width":"60px","height":"60px","object-fit":"cover","border-radius":"4px","cursor":"pointer"},
                                  alt: "Preview",
                                  onClick: ($event: any) => (abrirPreview(imagensPorPosicao.value[props.row.posicao].url!))
                                }, null, 8, _hoisted_16),
                                (!isViewMode.value)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      icon: "close",
                                      color: "negative",
                                      dense: "",
                                      flat: "",
                                      round: "",
                                      size: "sm",
                                      onClick: ($event: any) => (removerImagem(props.row.posicao))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, "Sem imagem"))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-download": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          (isViewMode.value && imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                icon: "download",
                                color: "primary",
                                dense: "",
                                round: "",
                                onClick: ($event: any) => (downloadImagem(imagensPorPosicao.value[props.row.posicao].url as string))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-upload": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            dense: "",
                            "no-caps": "",
                            icon: "upload",
                            label: "Upload",
                            disable: isViewMode.value,
                            onClick: ($event: any) => (onUploadClick(props.row.posicao))
                          }, null, 8, ["disable", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_expansion_item, {
      "expand-separator": "",
      icon: "menu",
      label: "Telas pós inserção do cartão",
      class: "accordion-item"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          true
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "midia-app-caption-sm q-mb-sm block" }, " Tela 1 – Aguarde a Leitura do Cartão (para todos os cartões) ", -1)),
                _createVNode(_component_q_table, {
                  flat: "",
                  dense: "",
                  "hide-pagination": "",
                  rows: safeTelasAguardeGeral.value,
                  columns: aguardeColumns.value,
                  "row-key": "id",
                  "table-class": "institutional-table"
                }, {
                  "body-cell-imagem": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          (imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("img", {
                                  src: imagensPorPosicao.value[props.row.posicao].url,
                                  style: {"width":"60px","height":"60px","object-fit":"cover","border-radius":"4px","cursor":"pointer"},
                                  alt: "Preview",
                                  onClick: ($event: any) => (abrirPreview(imagensPorPosicao.value[props.row.posicao].url!))
                                }, null, 8, _hoisted_23),
                                (!isViewMode.value)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      icon: "close",
                                      color: "negative",
                                      dense: "",
                                      flat: "",
                                      round: "",
                                      size: "sm",
                                      onClick: ($event: any) => (removerImagem(props.row.posicao))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, "Sem imagem"))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-download": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          (isViewMode.value && imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                icon: "download",
                                color: "primary",
                                dense: "",
                                round: "",
                                onClick: ($event: any) => (downloadImagem(imagensPorPosicao.value[props.row.posicao].url as string))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-upload": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            dense: "",
                            "no-caps": "",
                            icon: "upload",
                            label: "Upload",
                            disable: isViewMode.value,
                            onClick: ($event: any) => (onUploadClick(props.row.posicao))
                          }, null, 8, ["disable", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns"]),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "midia-app-caption-sm q-mt-lg q-mb-sm block" }, " Tela 2 – Tela Pré Menu de Transações para Cartões com Chip ", -1)),
                _createVNode(_component_q_table, {
                  flat: "",
                  dense: "",
                  "hide-pagination": "",
                  rows: safeTelasAguardeChip.value,
                  columns: aguardeColumns.value,
                  "row-key": "id",
                  "table-class": "institutional-table"
                }, {
                  "body-cell-imagem": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, [
                          (imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("img", {
                                  src: imagensPorPosicao.value[props.row.posicao].url,
                                  style: {"width":"60px","height":"60px","object-fit":"cover","border-radius":"4px","cursor":"pointer"},
                                  alt: "Preview",
                                  onClick: ($event: any) => (abrirPreview(imagensPorPosicao.value[props.row.posicao].url!))
                                }, null, 8, _hoisted_29),
                                (!isViewMode.value)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      icon: "close",
                                      color: "negative",
                                      dense: "",
                                      flat: "",
                                      round: "",
                                      size: "sm",
                                      onClick: ($event: any) => (removerImagem(props.row.posicao))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_30, "Sem imagem"))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-download": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_31, [
                          (isViewMode.value && imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                icon: "download",
                                color: "primary",
                                dense: "",
                                round: "",
                                onClick: ($event: any) => (downloadImagem(imagensPorPosicao.value[props.row.posicao].url as string))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-upload": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            dense: "",
                            "no-caps": "",
                            icon: "upload",
                            label: "Upload",
                            disable: isViewMode.value,
                            onClick: ($event: any) => (onUploadClick(props.row.posicao))
                          }, null, 8, ["disable", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_expansion_item, {
      "expand-separator": "",
      icon: "menu",
      label: "Tela de Abertura",
      class: "accordion-item"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          true
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "midia-app-caption-sm" }, " Apresenta para o Cliente? ", -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_q_radio, {
                      modelValue: apresentaParaCliente.value,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((apresentaParaCliente).value = $event)),
                        _cache[5] || (_cache[5] = ($event: any) => (usuarioAlterouApresentacao.value = true))
                      ],
                      val: "sim",
                      label: "Sim",
                      disable: isViewMode.value
                    }, null, 8, ["modelValue", "disable"]),
                    _createVNode(_component_q_radio, {
                      modelValue: apresentaParaCliente.value,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((apresentaParaCliente).value = $event)),
                        _cache[7] || (_cache[7] = ($event: any) => (usuarioAlterouApresentacao.value = true))
                      ],
                      val: "nao",
                      label: "Não",
                      disable: isViewMode.value
                    }, null, 8, ["modelValue", "disable"])
                  ])
                ]),
                _createVNode(_component_q_table, {
                  flat: "",
                  dense: "",
                  "hide-pagination": "",
                  rows: safeTelasAbertura.value,
                  columns: aberturaColumns.value,
                  "row-key": "id",
                  "table-class": "institutional-table"
                }, {
                  "body-cell-imagem": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_36, [
                          (imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("img", {
                                  src: imagensPorPosicao.value[props.row.posicao].url,
                                  style: {"width":"60px","height":"60px","object-fit":"cover","border-radius":"4px","cursor":"pointer"},
                                  alt: "Preview",
                                  onClick: ($event: any) => (abrirPreview(imagensPorPosicao.value[props.row.posicao].url!))
                                }, null, 8, _hoisted_38),
                                (!isViewMode.value)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      icon: "close",
                                      color: "negative",
                                      dense: "",
                                      flat: "",
                                      round: "",
                                      size: "sm",
                                      onClick: ($event: any) => (removerImagem(props.row.posicao))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_39, "Sem imagem"))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-download": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                          (isViewMode.value && imagensPorPosicao.value[props.row.posicao]?.url)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                icon: "download",
                                color: "primary",
                                dense: "",
                                round: "",
                                onClick: ($event: any) => (downloadImagem(imagensPorPosicao.value[props.row.posicao].url as string))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-upload": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            dense: "",
                            "no-caps": "",
                            icon: "upload",
                            label: "Upload",
                            disable: isViewMode.value || apresentaParaCliente.value === 'nao',
                            onClick: ($event: any) => (onUploadClick(props.row.posicao))
                          }, null, 8, ["disable", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_q_dialog, {
            modelValue: previewAberto.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((previewAberto).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"350px","max-width":"90vw"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center justify-between" }, {
                    default: _withCtx(() => [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-h6" }, "Preview da Imagem", -1)),
                      _withDirectives(_createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, { class: "q-pt-none row justify-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: previewUrl.value,
                        style: {"max-width":"100%","max-height":"70vh","border-radius":"4px"},
                        alt: "Preview"
                      }, null, 8, _hoisted_42)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      accept: "image/*",
      style: {"display":"none"},
      onChange: onFileSelected
    }, null, 544)
  ]))
}
}

})